"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppBadgeLink = exports.AppBadgeText = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

var _SuperLink = _interopRequireDefault(require("../../SuperLink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AppBadgeText = (0, _styledComponents["default"])(_slice.Headline).attrs({
  margin: 0,
  fontSize: 5,
  textAlign: ['center', 'right']
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  font-family: ", ";\n  font-weight: bold;\n  text-transform: uppercase;\n  line-height: 1;\n"], ["\n  font-family: ", ";\n  font-weight: bold;\n  text-transform: uppercase;\n  line-height: 1;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fonts.mrEaves;
});
exports.AppBadgeText = AppBadgeText;
var AppBadgeLink = (0, _styledComponents["default"])(_SuperLink["default"])(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  display: block;\n  line-height: 1;\n"], ["\n  display: block;\n  line-height: 1;\n"])));
exports.AppBadgeLink = AppBadgeLink;
var templateObject_1, templateObject_2;